import React from "react";
import { useSelector } from "react-redux";
import Support from "logistic-integrations/components/Support";
import { useTranslation } from "react-i18next";

function IfastSupport() {
  const { orderInfo } = useSelector((state) => state?.LogisticReducer);
  const { t } = useTranslation();
  return (
    <Support
      orderNo={
        orderInfo?.logisticPartnerMetadata?.IFAST?.trackingDeliveryInfo?.tracking_no
      }
      phone="+971600500555"
      heading={t("Ifast Order Tracking Number")}
      heading2={t("Ifast Helpline Number")}
    />
  );
}

export default IfastSupport;
